<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent transition="dialog-top-transition" max-width="600px">
      <v-card>
        <div class="container-visit">
          <div class="card-close">
            <img
              src="img/icons_v2/ico-close@3x.png"
              width="65px"
              height="65px"
              @click="$emit('close')"
            />
          </div>
          <div class="card-title">
            <h1>ไม่สามารถเข้าเยี่ยมได้</h1>
          </div>
          <div class="card-shop">
            <span>กรุณา Check-Out</span>
            <span>ร้าน {{ item.customer_name }} ก่อน</span>
          </div>
          <div class="mt-4">
            <button class="bt-submit" @click="$emit('close')">รับทราบ</button>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    item: Object
  }
}
</script>

<style lang="scss" scoped>
.container-visit {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 50px;
  border-radius: 10px;
}

.card-close {
  & img {
    position: absolute;
    top: 0px;
    right: 0px;
    margin: 10px;
  }
}
.card-title {
  margin: 20px 0px;
}

.card-shop {
  text-align: center;
  margin: 20px 0px;
  display: flex;
  flex-direction: column;
}

.bt-submit {
  width: 100%;
  background-color: #a50200;
  color: #ffffff;
  font-size: 25px;
  height: 65px;
  border-radius: 9px;
}

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 20px !important;
}
</style>
